export default "__VITE_ASSET__B8H9U155__"